<template>
  <div class="index">
    <Benefits />
    <Login />
  </div>
</template>

<script>
import Benefits from "../components/Benefits";
import Login from "../components/Login";
import common from "../mixins/common";

export default {
  name: "Index",
  mixins: [common],
  components: {
    Benefits,
    Login,
  },
  methods: {
    isAmoGo() {
      const client_type = this.clientType
      if(client_type === 'amogo'){
        return true
      }
      return false
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
